<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        iconClass: {
            type: String,
            default: null,
        },

    });

    const statusIcon = computed(() => {
        let statusIcon = "";
        if(props.iconClass == "03") {
            statusIcon = "preliminary"
        } else if(props.iconClass == "10") {
            statusIcon = "full-production";
        } else if(props.iconClass == "91" || props.iconClass == "93") {
            statusIcon = "not-for-new-design";
        } else if(props.iconClass == "95") {
            statusIcon = "orders-still-accepted"
        } else if(props.iconClass == "96" || props.iconClass == "97" || props.iconClass == "99") {
            statusIcon = "discontinued";
        }

        return statusIcon;
    });
</script>

<template>
    <svg v-if="statusIcon !== ''" class="icon icon-lifecycle " :class="statusIcon" width="22" height="32" viewBox="0 0 22 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="16" height="6" rx="1" class="bar is-top"/>
        <rect x="3" y="13" width="16" height="6" rx="1" class="bar is-middle"/>
        <rect x="3" y="23" width="16" height="6" rx="1" class="bar is-bottom"/>
        <path
            d="M1 1H21V-1H1V1ZM21 1V31H23V1H21ZM21 31H1V33H21V31ZM1 31V1H-1V31H1ZM1 31H1H-1C-1 32.1046 -0.104569 33 1 33V31ZM21 31V33C22.1046 33 23 32.1046 23 31H21ZM21 1H23C23 -0.10457 22.1046 -1 21 -1V1ZM1 -1C-0.104569 -1 -1 -0.10457 -1 1H1V-1Z"
            fill="#46555F" fill-opacity="0.24"/>
    </svg>
</template>
